import { Skeleton } from "antd";

export interface StepSkeletonInterface {
  size?: "s" | "m" | "l";
  width?: number;
  style?: React.CSSProperties;
}

export const StepSkeleton: React.FC<StepSkeletonInterface> = ({ size = "m", width = 200, style }) => {
  const getSize = (size: StepSkeletonInterface["size"]) => {
    switch (size) {
      case "l":
        return 32;
      case "m":
        return 24;
      case "s":
        return 16;
    }
  };
  return (
    <Skeleton
      active
      style={{ width: width }}
      title={{ width: width, style: { height: getSize(size), margin: 0, borderRadius: "4px", ...style } }}
      paragraph={{ rows: 0, style: { display: "none" } }}
    />
  );
};
